import React from 'react';
import styles from '../../styles/components/reports/ReportingHeader.module.css';
import { useSurveyContext } from 'contexts/SurveyContext';
import { getPanelTypeText } from '@ax2/common/model/PanelType';
import { AnswersCount } from 'model/reports/AnswersCount';
import { getAnswersCount } from 'rest/makeSurveyClient';
import { getMockedAnswerCount } from 'rest/mockedDataClient';
import config from '../../config';
import { useInterval } from 'helpers/hooks/useInterval';

export const ReportingHeader: React.FC = () => {
  const surveySchema = useSurveyContext();
  const [answers, setAnswers] = React.useState<AnswersCount>();

  const update = () => {
    async function updateAnswers() {
      if (surveySchema) {
        const answers = await getAnswersCount(surveySchema.id);
        setAnswers(answers);
      }
    }
    async function updateDemoAnswers() {
      setAnswers(getMockedAnswerCount());
    }
    config.type === 'demo' ? updateDemoAnswers() : updateAnswers();
  };
  // Update when schema is changed
  React.useEffect(update, [surveySchema]);
  // Polling update
  useInterval(update, config.pollingInterval, false);

  return (
    <div className={styles.surveyNameHeaderWrapper}>
      <div className={styles.surveyNameHeaderContainer}>
        <div className={styles.surveyInfoWrapper}>
          <div className={styles.surveyNameContainer}>
            <span className={styles.surveyName}>
              {surveySchema && surveySchema.title
                ? surveySchema.title
                : 'Untitled survey'}
            </span>
            {surveySchema && surveySchema.panel && (
              <span className={styles.panelNameText}>{`For ${getPanelTypeText(
                surveySchema.panel
              )} Panel`}</span>
            )}
          </div>
          <div className={styles.panelResponsesContainer}>
            <span className={styles.panelResponses}>
              {answers ? `${answers.current}/${answers.total}` : '0/0'}
            </span>
            <span className={styles.panelResponsesTitle}>Panel Responses</span>
          </div>
        </div>
      </div>
    </div>
  );
};
